const parallaxcraft = document.querySelectorAll('.img-block-img');
parallaxcraft.forEach(function (imgeMove) {
    gsap.set(imgeMove, {
        scale: 1.2,
    })
    const imageRect = imgeMove.getBoundingClientRect();
    const heightDifference = imageRect.height - imgeMove.parentElement.offsetHeight;
    gsap.fromTo(imgeMove, {
        y: -heightDifference,
    },
        {
            scrollTrigger: {
                trigger: imgeMove,
                start: 'top center+=30%',
                end: 'bottom+=10% top',
                scrub: true,
                // markers: true,
            },
            y: heightDifference,
            ease: 'none',
        })
})